import {
  type BooleanFilterTranslation,
  type DropdownFilterTranslation,
} from '@/components/filtering/filter-set/types'

import { type OrderMenuType, type OrderStatus, type OrderType } from '../types'

interface OrdersTranslations {
  filters2: Record<
    string,
    BooleanFilterTranslation | DropdownFilterTranslation | string
  >
  type: Record<OrderType, string>
  status: Record<OrderStatus, string>
  menuType: Record<OrderMenuType, string>
}

const typeOptions: Record<OrderType, string> = {
  delivery: 'Delivery',
  pickup: 'Pickup',
  store: 'Store',
}

const statusOptions: Record<OrderStatus, string> = {
  cancelled: 'Cancelled',
  claimed: 'In progress',
  completed: 'Completed',
  unclaimed: 'Not started',
  unconfirmed: 'Requested',
  voided: 'Voided',
}

const menuTypeOptions: Record<OrderMenuType, string> = {
  catering: 'Catering',
  olo: 'Online ordering',
}

export const ordersEn: OrdersTranslations = {
  filters2: {
    menuType: {
      label: 'Menu',
      options: menuTypeOptions,
    },
    status: {
      label: 'Status',
      options: statusOptions,
    },
    taxExemptionEnabled: {
      label: 'Tax status',
      options: {
        false: 'Taxed',
        true: 'Tax exempt',
      },
    },
    type: {
      label: 'Type',
      options: typeOptions,
    },
  },
  menuType: menuTypeOptions,
  status: statusOptions,
  type: typeOptions,
}
